module.exports = "/_next/static/images/twitter@2x-1a070196e7ffee6aff27a344a5550544.png";